__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@globalpayments-internal/zego-staff-web";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-auth-js", "8.0.1", () => (__webpack_require__.e(482).then(() => (() => (__webpack_require__(7482))))));
			register("@okta/okta-react", "6.11.0", () => (Promise.all([__webpack_require__.e(897), __webpack_require__.e(659)]).then(() => (() => (__webpack_require__(7897))))));
			register("@redux-devtools/extension", "4.0.0", () => (Promise.all([__webpack_require__.e(929), __webpack_require__.e(164)]).then(() => (() => (__webpack_require__(8164))))));
			register("@sentry/react", "10.75.1", () => (__webpack_require__.e(109).then(() => (() => (__webpack_require__(1109))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(241).then(() => (() => (__webpack_require__(9241))))));
			register("launchdarkly-js-client-sdk", "3.9.5", () => (__webpack_require__.e(596).then(() => (() => (__webpack_require__(2596))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(2483))), 1);
			register("react-redux", "9.3.0", () => (__webpack_require__.e(74).then(() => (() => (__webpack_require__(6074))))));
			register("react-router-dom", "6.30.6", () => (() => (__webpack_require__(1342))), 1);
			register("react-router", "6.30.6", () => (() => (__webpack_require__(8689))), 1);
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(4922))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(7810))), 1);
			register("redux-logger", "3.0.6", () => (__webpack_require__.e(46).then(() => (() => (__webpack_require__(1046))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(992).then(() => (() => (__webpack_require__(5992))))));
			initExternal(9879);
			initExternal(8332);
			initExternal(2991);
			initExternal(5707);
			initExternal(4555);
			initExternal(7047);
			initExternal(1779);
			initExternal(6567);
			initExternal(4031);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};